module.exports = __webpack_public_path__ + "img/waste_circumfrence_splash.66d1407c.jpg";